// extracted by mini-css-extract-plugin
export var highlightFade = "_29-4";
export var highlighted = "_29-3";
export var table = "_29-1";
export var tableContainer = "_29-0";
export var totalsRow = "_29-2";